import { useTimeout } from 'ahooks'
import { useSnackbar } from 'notistack'
import { memo } from 'react'
import { NotificationService } from '../../utils/notification'

export const NotificationHandler = memo(() => {
  const { enqueueSnackbar } = useSnackbar()

  useTimeout(() => {
    NotificationService.onMessage((payload) => {
      enqueueSnackbar(payload.notification.title, {
        variant: 'success',
        autoHideDuration: 5000,
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top',
        },
      })
    })
  }, 5000)
})
